import { createContext, useContext } from 'react';
import { roleAtLeast, type OrgRole } from '@harness/shared';

// Your role on the project being shown. Viewers read; editors work (chat, approvals, settings); owners administer.
// The server enforces all of this; the UI just doesn't offer what you can't do.
export const RoleContext = createContext<OrgRole>('owner');

export function useCan() {
  const role = useContext(RoleContext);
  return { role, edit: roleAtLeast(role, 'editor'), own: roleAtLeast(role, 'owner') };
}

export const VIEWER_HINT = 'You have view access to this project. Ask its creator for editor access.';
export const OWNER_HINT = 'Only the project’s creator can do this.';
